import React from 'react';
import {CommonProvider} from '@yandex-data-ui/common';

import {useStateSelector} from '~ui/hooks';
import {IS_MOBILE} from '~ui/constants';
import {selectUserSettingsState} from '~ui/store/slices/user-settings';

import {ConfirmProvider} from '~ui/components/ConfirmProvider/ConfirmProvider';

import {withRedux} from './with-redux';
import {withErrorBoundary} from './with-error-boundary';

export const withAppProviders = <Props extends object>(Component: React.FC<Props>) => {
    return withErrorBoundary(withRedux(withCommon(Component)));
};

const withCommon =
    <P extends {}>(Component: React.FC<P>) =>
    (props: P) => {
        const {theme, themeSettings} = useStateSelector(selectUserSettingsState);

        return (
            <CommonProvider
                theme={theme}
                systemLightTheme={themeSettings?.systemLightTheme}
                systemDarkTheme={themeSettings?.systemDarkTheme}
                mobile={IS_MOBILE}
            >
                <ConfirmProvider>
                    <Component {...props} />
                </ConfirmProvider>
            </CommonProvider>
        );
    };
